import { useMutation, useQueryClient } from '@tanstack/react-query';
import accesosService from '../services/accesosService';
import { accesosKeys } from '../queryKeys';

// POST /accesos (upsert: alta o reactivacion). Invalida la lista para reflejar
// el alta/reactivacion. El error se propaga (silent en el servicio) para que la
// pantalla muestre el mensaje del backend.
const useCrearAcceso = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ email, nombre }) =>
      accesosService.crearAcceso({ headquarter, email, nombre }),
    onSuccess: () => qc.invalidateQueries({ queryKey: accesosKeys.lista(headquarter) }),
  });
};

export default useCrearAcceso;
